import React from 'react';
import { Avatar } from '@progress/kendo-react-layout';
import { Check } from 'styled-icons/boxicons-regular';
import { CloseOutline } from 'styled-icons/evaicons-outline';
import { palette } from '../../../system/styles/styles';

export const CompanyCard = ({ data, handleCompany, showMore, addMulti, store }) => {
  const [state, setState] = React.useState({
    show: true,
    selected: false,
  });

  const openModal = () => {
    showMore('currentCompany', data, 'showCompanyModal');
  };

  const selectItem = () => {
    const selectedItems = store;
    if (state.selected) {
      const index = selectedItems.findIndex((it) => it === data);
      selectedItems.splice(index, 1);
      addMulti([...selectedItems]);
    } else {
      addMulti((prevState) => [...prevState, data]);
    }
  };

  React.useEffect(() => {
    const isSelected = store.indexOf(data);
    if (isSelected !== -1) {
      setState((prevState) => ({
        ...prevState,
        selected: true,
      }));
    } else {
      setState((prevState) => ({
        ...prevState,
        selected: false,
      }));
    }
  }, [store]);

  return (
    <div className="card">
      <Avatar type="text" size="large" onClick={selectItem}>
        <span>{`${data.companyName.charAt(0).toUpperCase()}${data.companyName.charAt(1).toUpperCase()}`}</span>
      </Avatar>
      <div className="userInfo" onClick={openModal} style={{ cursor: 'pointer' }}>
        <p className="userName">{`${data.companyName} `}</p>
        <p className="userData">{`${data.companyEmail} `}</p>
      </div>
      {!state.selected ? (
        <div className="userActions">
          <Check
            onClick={() => handleCompany(data, true)}
            size={20}
            color={palette.accept}
            style={{ cursor: 'pointer' }}
          />
          <CloseOutline
            onClick={() => handleCompany(data, false)}
            size={20}
            color={palette.red}
            style={{ cursor: 'pointer' }}
          />
        </div>
      ) : null}
    </div>
  );
};

export const UserCard = ({ userInfo, userAction, showMore, addMulti, store }) => {
  const userData = userInfo;

  const [state, setState] = React.useState({
    show: true,
    selected: false,
  });

  const openModal = () => {
    showMore('currentUser', userInfo, 'showUserModal');
  };

  const selectItem = () => {
    const selectedItems = store;
    if (state.selected) {
      const index = selectedItems.findIndex((it) => it === userInfo);
      selectedItems.splice(index, 1);
      addMulti([...selectedItems]);
    } else {
      addMulti((prevState) => [...prevState, userInfo]);
    }
  };

  React.useEffect(() => {
    const isSelected = store.indexOf(userInfo);
    if (isSelected !== -1) {
      setState((prevState) => ({
        ...prevState,
        selected: true,
      }));
    } else {
      setState((prevState) => ({
        ...prevState,
        selected: false,
      }));
    }
  }, [store]);

  return (
    <div className={state.show ? 'card' : 'hiddenCard'}>
      <Avatar
        type="text"
        size="large"
        onClick={selectItem}
        style={{
          backgroundColor: `#${  ((Math.random() * 0xffffff) << 0).toString(16).padStart(6, '0')}`,
          fontSize: '1.8rem',
        }}>
        <span>{userData.names.charAt(0).toUpperCase()}</span>
      </Avatar>
      <div className="userInfo" onClick={openModal} style={{ cursor: 'pointer' }}>
        <p className="userName">{`${userInfo.names} ${userInfo.lastNames}`}</p>
        <p className="userData">{`${userInfo.scholarID || userInfo.platformCampus} | ${userInfo.campusSegment || userInfo.email}`}</p>
        <p className="userData">{`${userInfo.career}`}</p>
      </div>
      {!state.selected ? (
        <div className="userActions">
          <Check
            onClick={() => userAction(userInfo, true)}
            size={20}
            color={palette.accept}
            style={{ cursor: 'pointer' }}
          />
          <CloseOutline
            onClick={() => userAction(userInfo, false)}
            size={20}
            color={palette.red}
            style={{ cursor: 'pointer' }}
          />
        </div>
      ) : null}
    </div>
  );
};

export const VacancyCard = ({ data, accept, reject, showMore, addMulti, store }) => {
  const [state, setState] = React.useState({
    show: true,
    selected: false,
  });

  const openModal = () => {
    showMore('currentVacancy', data, 'showVacancyModal');
  };

  const selectItem = () => {
    const selectedItems = store;
    if (state.selected) {
      const index = selectedItems.findIndex((it) => it === data);
      selectedItems.splice(index, 1);
      addMulti([...selectedItems]);
    } else {
      addMulti((prevState) => [...prevState, data]);
    }
  };

  const getSueldo = (sueldo) => {
    if (sueldo === 'Negociable') {
      return sueldo;
    }
    const arraySueldo = sueldo.trim().replaceAll('$', '').split('-');
    const newSueldo =  `$${new Intl.NumberFormat('es-MX').format(arraySueldo[0] || 0)} - $${new Intl.NumberFormat('es-MX').format(arraySueldo[1] || 0)}`;
    return newSueldo;
  }

  React.useEffect(() => {
    const isSelected = store.indexOf(data);
    if (isSelected !== -1) {
      setState((prevState) => ({
        ...prevState,
        selected: true,
      }));
    } else {
      setState((prevState) => ({
        ...prevState,
        selected: false,
      }));
    }
  }, [store]);

  return (
    <div className="card">
      <Avatar type="text" size="large" onClick={selectItem}>
        <span>{data.jobTitle.charAt(0).toUpperCase()}</span>
      </Avatar>
      <div className="userInfo" onClick={openModal} style={{ cursor: 'pointer' }}>
        <p className="userName">{`${data.jobTitle} `}</p>
        <p className="userData">{`${data.contract} | ${getSueldo(data.jobPay)}`}</p>
      </div>
      {!state.selected ? (
        <div className="userActions">
          <Check onClick={() => accept(data)} size={20} color={palette.accept} style={{ cursor: 'pointer' }} />
          <CloseOutline onClick={() => reject(data)} size={20} color={palette.red} style={{ cursor: 'pointer' }} />
        </div>
      ) : null}
    </div>
  );
};
